// extracted by mini-css-extract-plugin
export default {"report":"style--report--248fff","filters":"style--filters--3fc9d1","reportBody":"style--reportBody--f6edc8","backLink":"style--backLink--f3a24c","actions":"style--actions--686e90"};